// extracted by mini-css-extract-plugin
export default {"container":"ER-z","modal":"FR-z","dimensions":"GR-z","brandName":"HR-z","productName":"IR-z","labelValue":"JR-z","recipientEmail":"KR-z","recommendedFit":"LR-z","hiddenField":"MR-z"};